import React from "react";
import TransactionsContainer from "../../containers/Transaction";

function Expenses(props) {
  return <TransactionsContainer {...props} />;
}

export default Expenses;
